module.exports = __webpack_public_path__ + "static/media/cosimo-de-medici-di-toscana.96c599c4.jpg";